// removed by extract-text-webpack-plugin
module.exports = {"binary_breadcrum_container":"_264ixwzTFtI-xd4ydjGq4r","binary_breadcrum_item":"_3y_rKDZ1mOM-NklIYZqTFl","binary_breadcrum_item_last":"_1gODrg2njQO50uhsZhMSZq"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryBreadCrum/BinaryBreadCrum.scss
// module id = 2130
// module chunks = 1